export const privacyRightsOptions = [
	'form.privacyRights.access.option',
	'form.privacyRights.rectification.option',
	'form.privacyRights.optOut.option',
	'form.privacyRights.erasure.option',
	'form.privacyRights.portability.option',
	'form.privacyRights.withdrawConsent.option',
	'form.privacyRights.other.option',
]
